import { useContext, useState } from 'react'

import { WorkdayJobsContext } from '../WorkdayJobsContext'
import Activefilters from './Activefilters'
import Checkbox from './Checkbox'
import { WorkdayJobsFilterProps } from './WorkdayJobsFilterProps'

export default function WorkdayJobs({
  toggleOption,
  getOptions,
  getAvailableOptions,
  headerLabels,
  filterFields,
  resetField,
  applyFilter,
}: WorkdayJobsFilterProps) {
  const {
    openDropdown,
    tempSelections,
    filters,
    toggleDropdown,
    hidelocation,
    hidejobtype,
    hidetypeofcontract,
    hideexperience,
    hidejobfunction,
    hidebusinessunit,
    hideproductgroup,
    filteredJobscount,
  } = useContext(WorkdayJobsContext)

  const [isFilterbarOpened, setIsFilterbarOpened] = useState(false)

  const openFilterbarHandler = () => setIsFilterbarOpened(!isFilterbarOpened)
  const closeFiltersHandler = () => {
    setIsFilterbarOpened(false)
  }

  const HiddenfilterFields = {
    locations: hidelocation,
    primaryLocation: hidelocation,
    jobType: hidejobtype,
    typeOfContract: hidetypeofcontract,
    experience: hideexperience,
    jobFunction: hidejobfunction,
    businessUnit: hidebusinessunit,
    productGroup: hideproductgroup,
  }

  return (
    <div data-dm="filterbar.component" className="cmp-filterbar__container">
      <div className="cmp-filterbar">
        <button data-dm="filterbar.button" onClick={openFilterbarHandler} className="cmp-filterbar__button--is-open-filterbar">
          {'Filter'}
        </button>
        <div className={`cmp-filterbar__wrapper ${isFilterbarOpened ? 'cmp-filterbar__wrapper--is-open' : ''} `}>
          <div className="cmp-filterbar__header">
            <button
              onClick={() => toggleDropdown(openDropdown)}
              className={`cmp-filterbar__header--is-back ${isFilterbarOpened && !openDropdown ? 'cmp-filterbar__header--is-hidden' : ''} `}
            >
              <span className="icon-keyboard_arrow_left icon--md"></span>Back
            </button>
            <span className="cmp-filterbar__header-title">Filter by</span>
            <button
              className={`cmp-filterbar__header--is-close ${isFilterbarOpened && openDropdown ? 'cmp-filterbar__header--is-hidden' : ''}`}
              onClick={closeFiltersHandler}
              aria-labelledby="Close"
            >
              <span className="icon-close icon--md"></span>
            </button>
          </div>
          <div className="cmp-filterbar__body">
            <div className={`cmp-filterbar__filters ${openDropdown ? 'cmp-filterbar__filters--is-open' : ''}`}>
              {filterFields.map(field => {
                const label = headerLabels[field]
                const options = getOptions(field)
                const availableOptions = getAvailableOptions(field)
                const tempSelected = tempSelections[field] || []

                if (HiddenfilterFields[field]) {
                  return false
                }

                return (
                  <div key={field} className="cmp-filterbar__filter cmp-filterbar__filter-dropdown">
                    <label className="cmp-filterbar__dropdown-label" htmlFor={`${field}-group-label`}>
                      {label}
                    </label>

                    <div
                      className={`cmp-filterbar__dropdown ${openDropdown === field ? 'cmp-filterbar__dropdown--is-open' : ''} ${options?.length === 0 ? 'cmp-filterbar__dropdown--is-disabled' : ''}`}
                    >
                      <button
                        id={`${field}-group-label`}
                        className="cmp-filterbar__dropdown-button"
                        aria-label={`Filter toggle for: ${label}`}
                        onClick={() => toggleDropdown(field)}
                      >
                        <span className="cmp-filterbar__dropdown-button--desktop-label"></span>
                        <span className="cmp-filterbar__dropdown-button--mobile-label">{label}</span>
                        {filters[field]?.length && filters[field]?.length !== 0 ? (
                          <span className="cmp-filterbar__dropdown-button--selected-checkboxes">{filters[field].length}</span>
                        ) : (
                          ''
                        )}
                      </button>

                      {openDropdown === field && (
                        <div role="group" aria-labelledby={`${field}-group-label`} className="cmp-filterbar__dropdown-container">
                          <ul className="cmp-filterbar__dropdown-checkboxes">
                            {options.map((option, key) => (
                              <Checkbox
                                key={key}
                                option={option}
                                availableOptions={availableOptions}
                                field={field}
                                tempSelected={tempSelected}
                                toggleOption={toggleOption}
                              />
                            ))}
                          </ul>
                        </div>
                      )}
                      <div className="cmp-filterbar__dropdown-footer">
                        <button
                          className="cmp-filterbar__button cmp-filterbar__button--reset"
                          aria-label={`RESET: ${label}`}
                          onClick={() => resetField(field)}
                        >
                          <span className="icon--sm icon-reset icon-placement--before-label"></span>
                          <span className="cmp-filterbar__button-text">Reset</span>
                        </button>
                        <button
                          className="cmp-filterbar__button cmp-filterbar__button--select"
                          aria-label={`SELECT: ${label}`}
                          onClick={() => applyFilter(field)}
                        >
                          <span className="cmp-filterbar__button-text">Select</span>
                        </button>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
            <Activefilters />
          </div>
        </div>
        <div className="cmp-filterbar__footer">
          <button
            className="cmp-filterbar__button cmp-filterbar__button--select"
            onClick={openDropdown ? () => applyFilter(openDropdown) : closeFiltersHandler}
          >
            <span className="cmp-filterbar__button-text">{openDropdown ? 'Select' : `View ${filteredJobscount} Items`}</span>
          </button>
        </div>
      </div>
    </div>
  )
}
